var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.523 15.524 20 10 20C4.478 20 0 15.523 0 10C0 4.477 4.478 0 10 0C15.524 0 20 4.477 20 10ZM5.47 9.72C5.34298 9.84699 5.26575 10.0153 5.25236 10.1945C5.23896 10.3736 5.29029 10.5515 5.397 10.696L5.47 10.781L9.47 14.781C9.59705 14.9083 9.7656 14.9857 9.94493 14.9991C10.1243 15.0125 10.3024 14.961 10.447 14.854L10.532 14.781L14.532 10.78C14.6662 10.6462 14.7447 10.4665 14.7519 10.2771C14.759 10.0877 14.6941 9.90268 14.5704 9.75916C14.4466 9.61563 14.2731 9.52428 14.0847 9.50348C13.8964 9.48267 13.7071 9.53395 13.555 9.647L13.471 9.719L10.751 12.441L10.751 5.75C10.7512 5.56844 10.6855 5.39297 10.5662 5.25615C10.4468 5.11933 10.2819 5.03045 10.102 5.006L10 5.001C9.81876 5.00101 9.64366 5.06664 9.50707 5.18577C9.37048 5.30489 9.28165 5.46945 9.257 5.649L9.25 5.751L9.25 12.441L6.53 9.721C6.40301 9.59398 6.23466 9.51675 6.05555 9.50336C5.87644 9.48996 5.69847 9.54129 5.554 9.648L5.47 9.721V9.72Z",
    fill: "#078950"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0738de0b.svg";
export { ForwardRef as ReactComponent };